import styled, { css } from 'styled-components';

export const Wrapper = styled.label`
    position: relative;
    display: flex;
`;

export const Indicator = styled.span<{ disabled?: boolean }>`
    display: inline-block;
    cursor: pointer;
    width: 36px;
    height: 22px;
    position: relative;
    border-radius: 15px;
    background: ${props =>
        props.disabled ? props.theme.root.colors.basicColors['4%'] : props.theme.root.colors.basicColors['30%']};
    transition: background 0.2s;

    &:before {
        content: '';
        display: block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        position: absolute;
        top: 2px;
        left: 2px;
        background: ${props =>
            props.disabled
                ? props.theme.root.colors.basicColors['30%']
                : props.theme.root.colors.basicColors.white['100%']};
        transition: transform 0.2s;
    }

    ${props =>
        props.disabled &&
        css`
            cursor: default;
        `}
`;

export const Input = styled.input`
    position: absolute;
    z-index: -1;
    visibility: hidden;

    &:checked + ${Indicator} {
        background: ${props =>
            props.disabled
                ? props => props.theme.root.colors.system['success40%']
                : props.theme.root.colors.system.successDefault};

        &:before {
            transform: translateX(75%);
        }
    }
`;
